import { render } from "./px-message-bar.vue?vue&type=template&id=a74a2040&scoped=true&ts=true"
import script from "./px-message-bar.vue?vue&type=script&lang=ts"
export * from "./px-message-bar.vue?vue&type=script&lang=ts"

import "./px-message-bar.vue?vue&type=style&index=0&id=a74a2040&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74a2040"]])

export default __exports__